import { Button } from "common/buttons";
import * as React from "react";
import { ContentType, Parent } from "./CreateContent";

interface Props {
  parent: Parent;
  handleClick: React.Dispatch<ContentType | null>;
}

export const CreateContentOptions: React.FC<React.PropsWithChildren<Props>> = ({
  parent,
  handleClick,
}) => {
  let buttons = null;
  switch (parent) {
    case "folder":
      buttons = {
        folder: "Mappe",
        article: "Artikkel",
        multipleChoice: "Flervalgsoppgave",
        groupingExercise: "Grupperingsoppgave",
        kurssloeyfe: "Kurssløyfe",
      };
      break;
    case "selfAssessmentsContainer":
      buttons = {
        selfAssessment: "Selvtest",
      };
      break;
    case "selfAssessment":
      buttons = {
        article: "Artikkel",
        multipleChoice: "Flervalgsoppgave",
        groupingExercise: "Grupperingsoppgave",
      };
      break;
    case "kurssloeyfe":
      buttons = {
        article: "Artikkel",
        multipleChoice: "Flervalgsoppgave",
        groupingExercise: "Grupperingsoppgave",
      };
      break;
    case "studyProgramme":
      buttons = {
        folder: "Mappe",
        selfAssessmentsContainer: "Selvtestmappe",
        examSyllabus: "Pensum",
      };

      break;
  }
  return (
    <div key="buttons">
      {Object.entries(buttons).map(([key, value]) =>
        value ? (
          <Button
            key={key}
            onClick={() => {
              handleClick(key as ContentType);
            }}
          >
            {value}
          </Button>
        ) : null,
      )}
    </div>
  );
};
